export default {
  //ロール環境
  //API_BASE_URL: 'http://localhost:8080'

  //開発環境
  //API_BASE_URL: 'https://denemon-test.qnext.kyuden.co.jp'

  //本番環境
  //API_BASE_URL: 'https://denemon.qnext.kyuden.co.jp'

  //本番環境(多回路)
  API_BASE_URL: 'https://mc.denemon-iot.com'

}